export default "__VITE_ASSET__b268f544__"